import { useContext } from 'react';
import { TimeTrackerContext } from '@prodelio/context/time-tracker/TimeTracker.context';

export const useTimeTrackerContext = () => {
  return useContext(TimeTrackerContext);
};
